module.exports = __webpack_public_path__ + "media/images/amenities_icons/community_app-53b16052ce6213a4337499165dffb2ad.svg";